import React, { Component } from 'react';
import { CssBaseline, Button, Grid, withStyles, Typography } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { EVENT_IMG } from '../constants';

import Emergency from './dialogs/Emergency';
import MainContext from '../MainContext';
import ProgramDialog from '../program/ProgramDialog';
import Topbar from './Topbar';
import BaseDialog from './dialogs/BaseDialog';
import FAQ from '../faq/FAQ';
import NoticeDialog from './dialogs/NoticeDialog';
import WelcomeMsg from './dialogs/WelcomeMsg';
import SupportDialog from './dialogs/SupportDialog';

import './Main.css';
import { BsArrowRightCircle } from 'react-icons/bs';
import EventDialog from './dialogs/EventDialog';
import moment from 'moment';
// import { GiPartyPopper } from 'react-icons/gi';
// import { ImCalendar } from 'react-icons/im';
// import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';

const styles = (theme) => ({
  root: {
    overflowX: 'hidden',
    overflowY: 'auto',
    // overflowY: 'hidden',
    width: '100%',
    height: 'calc(100vh - 85px)',
  },
  grid: {
    width: 1200,
    marginTop: 40,
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 20px)',
    },
  },
  paper: {
    padding: theme.spacing(3),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  rangeLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(2),
  },
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 32,
  },
  outlinedButtom: {
    textTransform: 'uppercase',
    margin: theme.spacing(1),
  },
  actionButtom: {
    textTransform: 'uppercase',
    margin: theme.spacing(1),
    width: 152,
  },
  blockCenter: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  block: {
    padding: theme.spacing(2),
  },
  box: {
    marginBottom: 40,
    height: 65,
  },
  inlining: {
    display: 'inline-block',
    marginRight: 10,
  },
  buttonBar: {
    display: 'flex',
  },
  alignRight: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  noBorder: {
    borderBottomStyle: 'hidden',
  },
  loadingState: {
    opacity: 0.05,
  },
  loadingMessage: {
    position: 'absolute',
    top: '40%',
    left: '40%',
  },
  mobileRoot: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    overflowY: 'auto',
    position: 'relative',
    backgroundImage: `url('${EVENT_IMG}/main_bg_mob.png')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
  },
  mobileKsicLogo: {
    width: '50vw',
  },
  mobileBtn1: {
    // backgroundColor: theme.palette.secondary.main,
    backgroundColor: '#9b3330',
    borderRadius: '5px',
    marginBottom: '10px',
  },
  mobileBtn2: {
    backgroundColor: '#08d8a0',
    borderRadius: '5px',
  },
  mobileBtn1Text: {
    color: theme.palette.primary.main,

    fontWeight: 'bold',
    textTransform: 'none',
  },

  mobileBtn3: {
    borderRadius: '5px',
    border: '1px solid #efefef',
    backgroundColor: theme.palette.primary.main,
    color: '#ffffff',
    padding: '0 10px',
    height: '55px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'none',
    width: '98%',
    wordBreak: 'keep-all',
  },

  mobileBtn4: {
    height: '60px',
    textAlign: 'center',
    backgroundColor: theme.palette.primary.main,
    padding: '15px',
    borderRadius: '5px',
  },
  mobileBtn4Ic: {
    width: '1.5em',
    verticalAlign: 'text-top',
  },
  mobileBtn4Text: {
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  mobileBtnArrow: {
    // width: '100%',
    height: '1em',
  },
  footer: {
    height: '89px',
    marginTop: '-10px',
    backgroundColor: '#fbfbfb',
    display: 'flex',
    alignItems: 'center',

    fontSize: '17.5px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#b9b9b9',
    marginBottom: '38px',
  },
});

// const HtmlTooltip = withStyles((theme) => ({
//   tooltip: {
//     backgroundColor: '#E84545',
//     padding: 10,
//     color: 'white',
//     textShadow: '0px 1px 1.4px rgba(123, 85, 0, 0.2)',
//     maxWidth: 220,
//     fontSize: theme.typography.pxToRem(15),
//     boxShadow: '2px 2px 3px 2px rgba(0, 0, 0, 0.1)',
//   },
//   arrow: {
//     color: '#E84545',
//   },
// }))(Tooltip);

// const HtmlTooltip2 = withStyles((theme) => ({
//   tooltip: {
//     backgroundColor: '#E84545',
//     padding: 10,
//     color: 'white',
//     textShadow: '0px 4px 1.4px rgba(123, 85, 0, 0.2)',
//     maxWidth: 220,
//     fontSize: theme.typography.pxToRem(15),
//     boxShadow: '1px 1px 10px #fff, 0 0 20px 5px #f1c2c2',
//     animation: 'glow 2s infinite ease',
//   },
//   arrow: {
//     color: '#E84545',
//   },
// }))(Tooltip);

// const HtmlTooltip3 = withStyles((theme) => ({
//   tooltip: {
//     backgroundColor: '#122089',
//     padding: 10,
//     color: 'white',
//     textShadow: '0px 1px 1.4px rgba(123, 85, 0, 0.2)',
//     maxWidth: 220,
//     fontSize: theme.typography.pxToRem(15),
//     boxShadow: '2px 2px 3px 2px rgba(0, 0, 0, 0.1)',
//   },
//   arrow: {
//     color: '#122089',
//   },
// }))(Tooltip);

const today = moment().format('YYYYMMDD');

class Main extends Component {
  static contextType = MainContext;

  constructor(props) {
    super(props);
    this.goToPage = this.goToPage.bind(this);
    this.state = {
      learnMoredialog: false,
      getStartedDialog: false,
      satellitesDialog: false,
      faqDialog: false,
      noticeDialog: false,
      welcomeMsgDialog: false,
      scoreDialog: false,
      emergencyDialog: false,
      supportDialog: false,
      programDialog: false,
      eventDialog: false,
      matches: window.matchMedia('(max-width:992px)').matches,
    };
    // console.log(props.match.params.id);
  }

  componentDidMount() {
    console.log(this.context);
    // setInterval(() => {
    //   this.context[1].setCurrentTime(this.context[0].currentTime++);
    // }, 1000);
    // const handler = (e) => this.setState({ matches: e.matches });
    if (
      window.screen.width < 500 ||
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i)
    ) {
      this.setState({ matches: true }, this.moveToSignIn);
    } else {
      this.setState({ matches: false }, this.moveToSignIn);
    }
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia('(max-width:992px)').addListener(handler);

    if (today === '20220415' || today === '20220416' || today === '20220414') {
      this.syncServerTIme();
    }
    if (this.state.iv) {
      clearInterval(this.state.iv);
    }
  }

  componentWillUnmount() {
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia('(max-width:992px)').removeListener(handler);
  }

  moveToSignIn = () => {
    if (!sessionStorage.getItem('_in_user_')) {
      this.props.history.push('signin');
    }
  };

  goToPage(_move) {
    // if (_move === 'program') {
    //   window.open('https://innon.s3.ap-northeast-2.amazonaws.com/KCR2020/KCR+2020+Program+Book.pdf', '_blank');
    // } else {
    //   this.props.history.push(_move);
    // }
    this.props.history.push(_move);
  }

  openDialog = (event) => {
    this.setState({ learnMoredialog: true });
  };

  dialogClose = (event) => {
    this.setState({ learnMoredialog: false });
  };

  openSatellitesDialog = (event) => {
    this.setState({ satellitesDialog: true });
  };

  closeSatellitesDialog = (event) => {
    this.setState({ satellitesDialog: false });
  };

  openGetStartedDialog = (event) => {
    this.setState({ getStartedDialog: true });
  };

  closeGetStartedDialog = (event) => {
    this.setState({ getStartedDialog: false });
  };

  openFAQDialog = (event) => {
    this.setState({ faqDialog: true });
  };

  closeFAQDialog = (event) => {
    this.setState({ faqDialog: false });
  };

  openNoticeDialog = (event) => {
    this.setState({ noticeDialog: true });
  };
  closeNoticeDialog = (event) => {
    this.setState({ noticeDialog: false });
  };

  openWelcomeMsgDialog = (event) => {
    this.setState({ welcomeMsgDialog: true });
  };
  closeWelcomeMsgDialog = (event) => {
    this.setState({ welcomeMsgDialog: false });
  };

  openScoreDialog = (event) => {
    this.setState({ scoreDialog: true });
  };
  closeScoreDialog = (event) => {
    this.setState({ scoreDialog: false });
  };

  openEmergency = (event) => {
    this.setState({ emergencyDialog: true });
  };
  closeEmergency = (event) => {
    this.setState({ emergencyDialog: false });
  };

  openSupportDialog = (event) => {
    this.setState({ supportDialog: true });
  };
  closeSupportDialog = (event) => {
    this.setState({ supportDialog: false });
  };

  clickVOD() {
    const ele = document.getElementById('video-popup');
    ele.className += ' reveal-welcome';
    const vodAddress =
      navigator.userAgent.toLowerCase().indexOf('iphone') !== -1 ||
      navigator.userAgent.toLowerCase().indexOf('android') !== -1 ||
      navigator.userAgent.toLowerCase().indexOf('mobile') !== -1
        ? 696342383
        : 696342383;
    ele.innerHTML += `
      <div class="video-wrapper-welcome" id="video-wrapper">
        <div class="video-popup-close-btn" id="video-popup-close-btn">
          <img src="/images/common/ic_close.png" />
        </div>
        <iframe width="560" height="315" style="visibility:hidden;" onload="this.style.visibility='visible';" src="https://player.vimeo.com/video/${vodAddress}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen=""></iframe>
      </div>`;
  }
  closePopup() {
    const ele = document.getElementById('video-popup');
    const child = document.getElementById('video-wrapper');
    ele.removeChild(child);
    ele.className = ele.className.replace(' reveal-welcome', '');
  }

  syncServerTIme = () => {
    let now = moment();
    this.checkAssembly(now);
    const iv = setInterval(() => {
      now = moment();
      this.checkAssembly(now);
    }, 1000 * 60);
    this.setState({ iv: iv });
  };

  checkAssembly = (n) => {
    // 1st day
    // const showTime = moment('17:35', 'HHmm');
    // const hideTime = moment('18:40', 'HHmm');
    // 2nd day
    const showTime = moment('18:10', 'HHmm');
    const hideTime = moment('19:20', 'HHmm');
    let isShow = n.isSameOrAfter(showTime) && n.isBefore(hideTime);

    // console.log('showTime', showTime.format('YYYYMMDD HH:mm:ss'), isShow);
    // console.log('isShow', isShow);
    if (isShow) {
      if (sessionStorage.getItem('aseemblyShow')) isShow = false;
      sessionStorage.setItem('aseemblyShow', true);
      this.setState({ eventDialog: isShow });
    }
  };

  render() {
    const { classes } = this.props;
    return this.state.matches ? (
      // 모바일
      <div className={classes.mobileRoot}>
        <div style={{ width: '100%', height: '100%', padding: '0 20px', justifyContent: 'flex-start', zIndex: 111 }}>
          <Grid container justifyContent="flex-end" alignItems="center" style={{ paddingTop: '20px' }}>
            <Grid item xs={8}>
              <img src={`${EVENT_IMG}/logo_mob.png`} alt={'img'} style={{ width: '100%' }} />
            </Grid>
          </Grid>
          <Grid container style={{ justifyContent: 'flex-start', padding: '30px 0' }}>
            <Grid item>
              <img src={`${EVENT_IMG}/login_text.png`} style={{ width: '100%' }} alt={'logo'} />
            </Grid>
          </Grid>

          <Grid container alignContent="center" justifyContent="flex-end" style={{ paddingBottom: '8px' }}>
            <img
              src={`${EVENT_IMG}/kakao_logo.png`}
              alt={'kakao'}
              onClick={() => {
                window.open('https://pf.kakao.com/_Zxkbab');
              }}
              style={{ height: 35, width: 35 }}
            />
            {/* <Grid
              container
              justifyContent="center"
              alignContent="center"
              style={{ cursor: 'pointer', borderRadius: '15px', height: 60, width: 60 }}
              onClick={() => {
                window.open('https://pf.kakao.com/_Zxkbab');
              }}
            >
              <img src={`${EVENT_IMG}/kakao_logo.png`} alt={'kakao'} style={{ height: 35, width: 35 }} />
            </Grid> */}
          </Grid>
          <Grid container>
            {/* 버튼1 */}
            <Grid
              item
              xs={12}
              onClick={() => {
                this.goToPage('session');
              }}
              className={classes.mobileBtn1}
            >
              <Grid container style={{ padding: '30px 20px' }} justifyContent="space-between" alignItems="center">
                <Typography className={classes.mobileBtn1Text} style={{ fontSize: '24px', color: '#fff' }}>
                  Session
                </Typography>
                <BsArrowRightCircle color={'primary'} style={{ color: '#ffffff' }} size={24} />
              </Grid>
            </Grid>

            {/* 버튼 2 */}
            <Grid
              item
              xs={6}
              onClick={() => {
                this.goToPage('poster/0');
              }}
            >
              <Grid container>
                <Grid
                  container
                  style={{ padding: '20px 20px', marginRight: '5px', backgroundColor: '#08d8a0', borderRadius: '5px' }}
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid container justifyContent="flex-start">
                    <Typography className={classes.mobileBtn1Text} style={{ fontSize: '20px' }}>
                      E-Poster
                    </Typography>
                  </Grid>
                  <Grid container justifyContent="flex-end">
                    <BsArrowRightCircle color={'primary'} style={{ color: '#025a3c' }} size={20} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              xs={6}
              onClick={() => {
                this.goToPage('exhibition');
              }}
            >
              <Grid container>
                <Grid
                  container
                  style={{ padding: '20px 20px', marginLeft: '5px', backgroundColor: '#08d8a0', borderRadius: '5px' }}
                  alignItems="center"
                >
                  <Grid container justifyContent="flex-start">
                    <Typography className={classes.mobileBtn1Text} style={{ fontSize: '20px' }}>
                      Exhibition
                    </Typography>
                  </Grid>
                  <Grid container justifyContent="flex-end">
                    <BsArrowRightCircle color={'primary'} style={{ color: '#025a3c' }} size={20} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* Welcome Message */}
            <Grid container item xs={12}>
              {/* <Grid
                container
                justifyContent="center"
                item
                xs={12}
                style={{ backgroundColor: '#fff', padding: '20px 0', borderRadius: '5px', margin: '20px 0' }}
                onClick={this.clickVOD}
              >
                <Typography style={{ color: '#035a3c', fontWeight: 'bold', fontSize: 'large' }}>Welcome Address</Typography>
              </Grid> */}
              <Grid container justifyContent="flex-start" item xs={6} style={{ margin: '10px 0' }}>
                <Button
                  onClick={this.clickVOD}
                  style={{ textTransform: 'none', width: '96.8%', backgroundColor: '#fff', padding: '10px 0', borderRadius: '5px' }}
                >
                  <Typography style={{ color: '#035a3c', fontWeight: 'bold' }}>
                    Welcome
                    <br />
                    Address
                  </Typography>
                </Button>
              </Grid>
              <Grid container justifyContent="flex-end" item xs={6} style={{ margin: '10px 0' }}>
                <Button
                  onClick={this.openFAQDialog}
                  style={{ textTransform: 'none', width: '96.8%', backgroundColor: '#fff', padding: '10px 0', borderRadius: '5px' }}
                >
                  <Typography style={{ color: '#035a3c', fontWeight: 'bold' }}>
                    Information
                    <br />
                    Desk
                  </Typography>
                </Button>
              </Grid>
            </Grid>
          </Grid>

          {/* 버튼 4개 Grid  */}
          <Grid container style={{ paddingBottom: '10vh' }}>
            <Grid container justifyContent="center" item xs={4}>
              <Grid
                container
                justifyContent="flex-end"
                alignContent="center"
                className={classes.mobileBtn3}
                onClick={this.openNoticeDialog}
                // style={{ marginLeft: '8px' }}
              >
                {/* <GiPartyPopper size={20} style={{ color: '#fff', marginRight: '8px' }} /> */}
                <Typography style={{ fontSize: '14px' }}>Event</Typography>
              </Grid>
            </Grid>

            <Grid container justifyContent="center" item xs={4}>
              <Grid
                container
                justifyContent="center"
                alignContent="center"
                className={classes.mobileBtn3}
                onClick={() => {
                  this.setState({ programDialog: true });
                }}
                // style={{ marginRight: '8px' }}
              >
                {/* <ImCalendar size={20} style={{ color: '#fff', marginRight: '8px' }} /> */}
                <Typography style={{ fontSize: '14px' }}>
                  VOD
                  <br />
                  다시보기
                </Typography>
              </Grid>
            </Grid>
            <Grid container justifyContent="center" item xs={4}>
              <Grid
                container
                justifyContent="center"
                alignContent="center"
                className={classes.mobileBtn3}
                onClick={() => {
                  this.goToPage('mypage');
                }}
                // style={{ marginLeft: '8px' }}
              >
                {/* <BsPerson size={20} style={{ color: '#fff', marginRight: '8px' }} /> */}
                <Typography style={{ fontSize: '14px' }}>My Page</Typography>
              </Grid>
            </Grid>
            {/* <Grid container justifyContent="flex-start" item xs={6} style={{ marginBottom: '16px' }}>
              <Grid
                container
                justifyContent="center"
                alignContent="center"
                className={classes.mobileBtn3}
                onClick={this.openFAQDialog}
                style={{ marginRight: '8px' }}
              >
                <BsInfoCircle size={20} style={{ color: '#fff', marginRight: '8px' }} />
                <Typography style={{ fontSize: '14px', textAlign: 'center' }}>
                  Information
                  <br />
                </Typography>
              </Grid>
            </Grid>

            <Grid container justifyContent="flex-end" item xs={6} style={{ marginBottom: '16px' }}>
              <Grid
                container
                justifyContent="center"
                alignContent="center"
                className={classes.mobileBtn3}
                onClick={this.openNoticeDialog}
                style={{ marginLeft: '8px' }}
              >
                <GiPartyPopper size={20} style={{ color: '#fff', marginRight: '8px' }} />
                <Typography style={{ fontSize: '14px', textAlign: 'center' }}>Event</Typography>
              </Grid>
            </Grid>

            <Grid container justifyContent="flex-start" item xs={6}>
              <Grid
                className={classes.mobileBtn3}
                onClick={() => {
                  this.setState({ programDialog: true });
                }}
                style={{ marginRight: '8px' }}
              >
                <ImCalendar size={20} style={{ color: '#fff', marginRight: '8px' }} />
                <Typography style={{ fontSize: '14px' }}>Program at a Glance</Typography>
              </Grid>
            </Grid>

            <Grid container justifyContent="flex-end" item xs={6}>
              <Grid
                className={classes.mobileBtn3}
                onClick={() => {
                  this.goToPage('mypage');
                }}
                style={{ marginLeft: '8px' }}
              >
                <BsPerson size={20} style={{ color: '#fff', marginRight: '8px' }} />
                <Typography style={{ fontSize: '14px' }}>My Page</Typography>
              </Grid>
            </Grid> */}
          </Grid>
        </div>
        <FAQ open={this.state.faqDialog} onClose={this.closeFAQDialog} disableBackdrop={false} />
        <EventDialog
          open={this.state.eventDialog}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ eventDialog: false });
            }
          }}
        />
        <NoticeDialog open={this.state.noticeDialog} onClose={this.closeNoticeDialog} disableBackdrop={false} />
        <WelcomeMsg open={this.state.welcomeMsgDialog} onClose={this.closeWelcomeMsgDialog} disableBackdrop={false} />
        <ProgramDialog open={this.state.programDialog} onClose={() => this.setState({ programDialog: false })} disableBackdrop={false} />
        <SupportDialog open={this.state.supportDialog} onClose={this.closeSupportDialog} disableBackdrop={false} />
        <div id="video-popup" className="video-popup" onClick={this.closePopup}>
          <div className="video-popup-closer"></div>
        </div>
      </div>
    ) : (
      // 웹
      <React.Fragment>
        <CssBaseline />
        <Topbar />
        <div id="main_container" className={classes.root}>
          {/* <div id="main_img" style={{ width: '100%', marginTop: '-65px', position: 'relative' }}> */}
          <div id="main_img" style={{ width: '100%', marginTop: '-85px', position: 'relative' }}>
            <img style={{ width: '100%', display: 'block' }} src={`${EVENT_IMG}/lobby_web.png`} alt="" />
            {/* <div className="main-satellite" onClick={() => this.goToPage('satellite')} /> */}
            <div className="main-session" onClick={() => this.goToPage('session')} />
            <div className="main-exhibition" onClick={() => this.goToPage('exhibition')} />
            <div className="main-poster" onClick={() => this.goToPage('poster/0')} />
            <div className="main-info" onClick={this.openFAQDialog} />
            <div className="main-btn-grid">
              <Grid container justifyContent="space-between" alignItems="center">
                <img
                  style={{ width: '30%', cursor: 'pointer' }}
                  src={`${EVENT_IMG}/btn_pag.png`}
                  alt={'program'}
                  onClick={() => {
                    this.setState({ programDialog: true });
                  }}
                />
                <img
                  style={{ width: '30%', cursor: 'pointer' }}
                  src={`${EVENT_IMG}/btn_mypage.png`}
                  alt={'mypage'}
                  onClick={() => {
                    this.goToPage('mypage');
                  }}
                />
                <img
                  style={{ width: '30%', cursor: 'pointer' }}
                  src={`${EVENT_IMG}/btn_evt.png`}
                  alt={'notice'}
                  onClick={this.openNoticeDialog}
                />
              </Grid>
            </div>
            <div className={'main-welcomemsg'} onClick={this.clickVOD} />
          </div>
          <BaseDialog
            open={this.state.getStartedDialog}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                this.setState({ getStartedDialog: false });
              }
            }}
          />
          <FAQ
            open={this.state.faqDialog}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                this.setState({ faqDialog: false });
              }
            }}
          />
          <NoticeDialog
            open={this.state.noticeDialog}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                this.setState({ noticeDialog: false });
              }
            }}
          />
          <ProgramDialog
            open={this.state.programDialog}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                this.setState({ programDialog: false });
              }
            }}
          />
          <WelcomeMsg
            open={this.state.welcomeMsgDialog}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                this.setState({ welcomeMsgDialog: false });
              }
            }}
          />

          <EventDialog
            open={this.state.eventDialog}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                this.setState({ eventDialog: false });
              }
            }}
          />
          {/* <Emergency
            open={this.state.emergencyDialog}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                this.setState({ emergencyDialog: false });
              }
            }}
          /> */}

          <Emergency
            open={this.state.emergencyDialog}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                this.setState({ emergencyDialog: false });
              }
            }}
          />
          {/*<Footer />*/}
        </div>
        <div id="video-popup" className="video-popup" onClick={this.closePopup}>
          <div className="video-popup-closer" style={{ position: 'relative' }}></div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Main));
